import React, { useState } from 'react';
import { COLORS, FONTS, GradientBanner } from '../signup/signupStyles';
import { OpportunityCard } from './OpportunityCard';

const VoteButton = ({ voted, onVote, count }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
    <button onClick={onVote} style={{
      width: '44px', height: '44px', borderRadius: '8px',
      border: voted ? `2px solid ${COLORS.salmon}` : `1.5px solid ${COLORS.border}`,
      backgroundColor: voted ? `${COLORS.salmon}10` : '#fff',
      cursor: voted ? 'default' : 'pointer',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'all 0.2s', fontSize: '16px'
    }}>
      <svg width="18" height="18" viewBox="0 0 24 24"
        fill={voted ? COLORS.salmon : 'none'}
        stroke={voted ? 'none' : COLORS.muted}
        strokeWidth={voted ? 0 : 2}
      >
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
    </button>
    <span style={{ fontSize: '13px', fontWeight: '600', color: voted ? COLORS.salmon : COLORS.text }}>
      {count}
    </span>
  </div>
);

export const ReflectResults = ({
  condition, communityAnswers, userAnswer, userState,
  answeredCount, hasMoreQuestions, opportunities, onNextQuestion, onSelectOpportunity, onDone
}) => {
  const [votes, setVotes] = useState(
    communityAnswers.reduce((acc, a) => ({ ...acc, [a.id]: a.votes }), {})
  );
  const [votedIds, setVotedIds] = useState([]);

  const handleVote = (id) => {
    if (votedIds.includes(id)) return;
    setVotes(prev => ({ ...prev, [id]: prev[id] + 1 }));
    setVotedIds(prev => [...prev, id]);
  };

  const showOpportunities = !hasMoreQuestions && opportunities.length > 0;

  return (
    <div style={{
      minHeight: '100vh', backgroundColor: COLORS.bg, padding: '60px 20px',
      fontFamily: FONTS.system
    }}>
      <GradientBanner />
      <style>{`
        @media (max-width: 600px) {
          .reflect-community-card { flex-direction: column !important; }
          .reflect-vote-section { flex-direction: row !important; width: 100% !important; justify-content: flex-start !important; }
        }
      `}</style>
      <div style={{ maxWidth: '680px', margin: '0 auto', textAlign: 'left' }}>

        {/* User's answer */}
        <div style={{
          backgroundColor: `${COLORS.salmon}08`, border: `2px solid ${COLORS.salmon}`,
          borderRadius: '12px', padding: '24px', marginBottom: '32px'
        }}>
          <div style={{
            fontSize: '12px', fontWeight: '600', textTransform: 'uppercase',
            letterSpacing: '1px', color: COLORS.salmon, marginBottom: '10px'
          }}>Your Answer</div>
          <p style={{ fontSize: '16px', color: COLORS.text, lineHeight: '1.6', margin: 0 }}>
            {userAnswer}
          </p>
        </div>

        {/* Community answers */}
        <h3 style={{
          fontSize: '13px', fontWeight: '600', textTransform: 'uppercase',
          letterSpacing: '1px', color: COLORS.muted, marginBottom: '16px'
        }}>
          How others answered
        </h3>

        {communityAnswers.map((item) => (
          <div key={item.id} className="reflect-community-card" style={{
            backgroundColor: '#fff', borderRadius: '12px', padding: '24px',
            marginBottom: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
            display: 'flex', gap: '20px'
          }}>
            <div className="reflect-vote-section">
              <VoteButton
                voted={votedIds.includes(item.id)}
                onVote={() => handleVote(item.id)}
                count={votes[item.id]}
              />
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: '15px', color: COLORS.text, lineHeight: '1.6', margin: '0 0 10px' }}>
                {item.text}
              </p>
              <div style={{ fontSize: '13px', color: COLORS.muted }}>
                {item.author} · diagnosed {item.diagnosisTime}
              </div>
            </div>
          </div>
        ))}

        {/* Opportunities (after 2+ answers) */}
        {showOpportunities && <OpportunityCard opportunities={opportunities} onSelect={onSelectOpportunity} />}

        {/* CTAs */}
        <div style={{
          marginTop: '40px', textAlign: 'center', padding: '32px',
          backgroundColor: '#fff', borderRadius: '16px',
          boxShadow: '0 2px 16px rgba(0,0,0,0.06)'
        }}>
          <p style={{
            fontFamily: FONTS.serif, fontSize: '20px', fontWeight: '600',
            color: COLORS.text, margin: '0 0 8px'
          }}>
            {hasMoreQuestions ? 'Great answer. Ready for the next one?' : 'Thank you for sharing.'}
          </p>
          <p style={{ fontSize: '15px', color: COLORS.muted, margin: '0 0 24px', lineHeight: '1.5' }}>
            {hasMoreQuestions
              ? `Question ${answeredCount} of 4 answered. Your responses help other ${condition} patients feel less alone.`
              : `Your answers help other ${condition} patients feel less alone. We'll notify you when new questions are available.`
            }
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {hasMoreQuestions && (
              <button onClick={onNextQuestion} style={{
                padding: '16px 32px', fontSize: '16px', fontWeight: '600', color: '#fff',
                background: `linear-gradient(135deg, ${COLORS.salmon} 0%, ${COLORS.peach} 50%, ${COLORS.gold} 100%)`,
                border: 'none', borderRadius: '8px', cursor: 'pointer',
                transition: 'transform 0.2s, box-shadow 0.2s'
              }}
                onMouseEnter={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 4px 12px rgba(235, 160, 155, 0.4)'; }}
                onMouseLeave={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
              >Next Question</button>
            )}
            <button onClick={onDone} style={{
              padding: '16px 32px', fontSize: '16px', fontWeight: '600',
              color: hasMoreQuestions ? COLORS.text : '#fff',
              background: hasMoreQuestions ? 'transparent' : `linear-gradient(135deg, ${COLORS.salmon} 0%, ${COLORS.peach} 50%, ${COLORS.gold} 100%)`,
              border: hasMoreQuestions ? `1.5px solid ${COLORS.border}` : 'none',
              borderRadius: '8px', cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
              onMouseEnter={(e) => { if (!hasMoreQuestions) { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 4px 12px rgba(235, 160, 155, 0.4)'; } }}
              onMouseLeave={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
            >Back to Home</button>
          </div>
        </div>
      </div>
    </div>
  );
};
